import { log } from './logger'

/*  Reusable navigator share function to be used by react and stimulus etc
 *   Details of Navigator share can be found here:
 *   https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
 */
const navigatorShare = (url, title, text) => {
  if (navigator.share) {
    navigator
      .share({
        title,
        text,
        url
      })
      .then() // TODO: Analytics on successful share
      .catch(log) // TODO: Analytics on aborted or failed share
  }
}

export default navigatorShare
